<div class="text-center">
  <h1 class="mb-0">404</h1>
  <h4 class="mt-0">Page not found</h4>
  <p *ngIf="errorMsg">
    {{ errorMsg }}
  </p>
  <app-back-to-start></app-back-to-start>
</div>
